import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

import Utils from 'general/utils/Utils'
import Message100 from './components/Message100'
import Message102 from './components/Message102'
import Message103 from './components/Message103'
import Message200 from './components/Message200'
import Message202 from './components/Message202'
import Message203 from './components/Message203'
import Message204 from './components/Message204'
import Message301 from './components/Message301/indexDocument'
import Message999 from './components/Message999'
import './style.scss'
import Message300 from './components/Message300'
import {
  REGISTRATION_TAX_MESS_ORDER,
  REGISTRATION_TAX_MESS_ORDER_CT,
  TypeCode_CQT,
} from 'general/constants/AppConstants'
import Message206 from './components/Message206'
import Message_1 from './components/Message_1'
import Message211 from './components/Message211'
import Message213 from './components/Message213'
import Message304 from './components/Message304'
import Message109 from './components/Message109'
import Message110 from './components/Message110'
import Message111 from './components/Message111'

function ModalDataTransmissionLogAD(props) {
  const navigate = useNavigate()

  const {
    show,
    onHide,
    registration,
    object,
    errAnnouce,
    summaryInvoice,
    isInvoice = true,
    viewPdfRegistration,
  } = props
  console.log('object', object)
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      dialogClassName="ModalDataTransmissionLog"
    >
      <Modal.Header closeButton>
        <Modal.Title>Nhật ký truyền nhận dữ liệu</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {registration && (
          <div>
            <div className="bg-secondary px-5 py-3">
              <div className="d-flex flex-row justify-content-between">
                <p className="mb-2 title">{registration.name}</p>
                <span
                  className="cursor-pointer p-1"
                  title="Xem tờ khai"
                  onClick={() =>
                    viewPdfRegistration(registration.registrationId)
                  }
                >
                  <i
                    className="fa-regular fa-eye"
                    style={{ color: '#3F4254' }}
                  ></i>
                </span>
              </div>
              <div className="d-flex flex-row">
                <p className="mb-2 mr-8">{`Số: ${registration.no}`}</p>
                <p className="mb-2">{`Ngày lập: ${registration.date}`}</p>
              </div>
            </div>

            <div className="px-5 py-3 message-container">
              {registration.tax_authority_messages
                ?.sort(
                  (a, b) =>
                    REGISTRATION_TAX_MESS_ORDER_CT[a.typeCode] -
                    REGISTRATION_TAX_MESS_ORDER_CT[b.typeCode],
                )
                ?.map((message, index) =>
                  message.typeCode == 102 ? (
                    <Message102 key={index} message={message} />
                  ) : message.typeCode == 100 ? (
                    <Message100 key={index} message={message} />
                  ) : message.typeCode == 103 ? (
                    <Message103 key={index} message={message} />
                  ) : message.typeCode == 109 ? (
                    <Message109 key={index} message={message} />
                  ) : message.typeCode == 110 ? (
                    <Message110 key={index} message={message} />
                  ) : message.typeCode == 111 ? (
                    <Message111 key={index} message={message} />
                  ) : message.typeCode == 999 ? (
                    <Message999 key={index} message={message} />
                  ) : (
                    <></>
                  ),
                )}
            </div>
          </div>
        )}
        {object && (
          <div>
            <div className="bg-secondary px-5 py-3">
              <div className="d-flex flex-row justify-content-between">
                <p className="mb-2 font-weight-bold">
                  Lịch sử truyền nhận chứng từ
                </p>
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex flex-row justify-content-between">
                  <div className="d-flex flex-column">
                    <p className="mb-2 mr-8">{`Tên: ${object?.taxpayersName}`}</p>
                    <p className="mb-2 mr-8">{`Mã số thuế: ${object?.employeeTaxCode}`}</p>
                    <p className="mb-2 mr-8">{`Số: ${object?.numberDocument}`}</p>
                    <p className="mb-2 mr-8">{`CCCD/HC: ${object?.employeeIdentification}`}</p>
                    <p className="mb-2">{`Ngày tạo: ${Utils.formatDate(
                      object?.createDate,
                      'DD-MM-YYYY',
                    )}`}</p>
                  </div>
                  <div className="d-flex flex-column">
                    <span
                      style={{ fontSize: '20px', fontWeight: '600' }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-5 py-3 message-container">
              {[...object.tax_authority_messages]
                .sort((a, b) => {
                  const order = [
                    TypeCode_CQT.CHUNG_TU.CQT_TRA_KET_QUA_PHAT_HANH_CHUNG_TU, // 213
                    TypeCode_CQT.KHAC.LOI_TO_KHAI, // 999
                    TypeCode_CQT.CHUNG_TU.GUI_CQT, // 211
                  ]
                  return order.indexOf(a.typeCode) - order.indexOf(b.typeCode)
                })
                .map((message, index) => {
                  switch (message.typeCode) {
                    case TypeCode_CQT.CHUNG_TU.GUI_CQT:
                      return <Message211 key={index} message={message} />
                    case TypeCode_CQT.CHUNG_TU
                      .CQT_TRA_KET_QUA_PHAT_HANH_CHUNG_TU:
                      return <Message213 key={index} message={message} />
                    case TypeCode_CQT.KHAC.LOI_TO_KHAI:
                      return <Message999 key={index} message={message} />
                    default:
                      return null
                  }
                })}
            </div>
          </div>
        )}
        {errAnnouce && (
          <div>
            <div className="bg-secondary px-5 py-3">
              <div className="d-flex flex-row justify-content-between">
                <p className="mb-2 font-weight-bold">
                  Lịch sử truyền nhận thông báo
                </p>
              </div>
            </div>

            <div className="px-5 py-3 message-container">
              {errAnnouce.tax_authority_messages?.map((message, index) => {
                switch (message.typeCode) {
                  case 300:
                    return <Message300 key={index} message={message} />
                  case 301:
                    return <Message301 key={index} message={message} />
                  case 204:
                    return <Message204 key={index} message={message} />
                  case 213:
                    return <Message213 key={index} message={message} />
                  case 304:
                    return <Message304 key={index} message={message} />
                  case 999:
                    return <Message999 key={index} message={message} />

                  default:
                }
              })}
            </div>
          </div>
        )}
        {summaryInvoice && (
          <div>
            <div className="bg-secondary px-5 py-3">
              <div className="d-flex flex-row justify-content-between">
                <p className="mb-2 font-weight-bold">
                  Chuyển dữ liệu hóa đơn khởi tạo từ máy tính tiền đến cơ quan
                  thuế
                </p>
              </div>
              <div className="d-flex flex-row">
                <p className="mb-2 mr-8">{`Số lượng hóa đơn: ${summaryInvoice.invoiceQuantity}`}</p>
              </div>
            </div>

            <div className="px-5 py-3 message-container">
              {summaryInvoice.tax_authority_messages
                ?.sort(
                  (a, b) =>
                    REGISTRATION_TAX_MESS_ORDER[a.typeCode] -
                    REGISTRATION_TAX_MESS_ORDER[b.typeCode],
                )
                ?.map((message, index) =>
                  message.typeCode == 206 ? (
                    <Message206 key={index} message={message} />
                  ) : message.typeCode == 204 ? (
                    <Message204 key={index} message={message} />
                  ) : message.typeCode == -1 ? (
                    <Message_1 key={index} message={message} />
                  ) : message.typeCode == 213 ? (
                    <Message213 key={index} message={message} />
                  ) : message.typeCode == 999 ? (
                    <Message999 key={index} message={message} />
                  ) : (
                    <></>
                  ),
                )}
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  )
}

export default ModalDataTransmissionLogAD
